module.exports = __webpack_public_path__ + "img/1.017d83c2.png";